// src/app/companies/constants/company-import-headers.const.ts
export const COMPANY_IMPORT_HEADERS = ['Name', 'Description', 'IsSubcontractor'] as const;

export type CompanyImportHeader = (typeof COMPANY_IMPORT_HEADERS)[number];